import { systemProduction, annualSolarSavings } from '../solar/selectors';


export const ppaRateForYear = (year, prevPpaRate, state) => {
    const { escalator } = state.ppa;

    if (year === 1) return prevPpaRate;

    return prevPpaRate * (1 + (escalator / 100));
};

export const formattedPPABill = (year, prevPpaRate, state) => {
    const ppaBill = ppaRateForYear(year, prevPpaRate, state)
        * systemProduction(state)[year];
    return ppaBill.toFixed(0);
};

export const ppaBill = (year, prevPpaRate, state) => {
    const bill = ppaRateForYear(year, prevPpaRate, state)
        * systemProduction(state)[year];
    return bill;
};


export const annualPPASavings = (state, year, prevPpaRate, prevSolarValue) => {
    const ppaSavings = annualSolarSavings(year, prevSolarValue, state)
        - ppaBill(year, prevPpaRate, state);

    return ppaSavings;
};

export const formattedAnnualPPASavings = (state, year, prevPpaRate, prevSolarValue) => {
    const ppaSavings = annualSolarSavings(year, prevSolarValue, state)
        - ppaBill(year, prevPpaRate, state);

    return ppaSavings.toFixed(0);
};



// WEBPACK FOOTER //
// ./src/containers/common/ppa/selectors.js